import { useLayoutEffect, useRef, useState, type RefObject } from 'react';

// Measured before paint, so a chart built from the width draws right the first time. The ref must go on an element
// rendered on mount: layout effects run after refs attach.
export function useElementWidth<T extends HTMLElement>(): [RefObject<T | null>, number] {
  const ref = useRef<T>(null);
  const [width, setWidth] = useState(0);
  useLayoutEffect(() => {
    const node = ref.current as T;
    const measure = (): void => setWidth(node.clientWidth);
    measure();
    const observer = new ResizeObserver(measure);
    observer.observe(node);
    return () => observer.disconnect();
  }, []);
  return [ref, width];
}
